<template>

    <div class="code_box" @click="randomNUmber">
        <div class="number">
            {{ firstNumber }}
        </div>
        <div class="type">
            <span v-if="type == 0">
                +
            </span>
            <span v-if="type == 1">
                -
            </span>
            <span v-if="type == 2">
                *
            </span>
        </div>
        <div class="number">
            {{ secondNumber }}
        </div>
        <div class="value">
            = ?
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // code: "",
                type: "",
                firstNumber: "",
                secondNumber: "",
                colorList: ['red','orange','blue','yellow','black'],
                // colorIndex: 0,
                max: 10,
                min: 10,
            }
        },
        props: {
            checkCode: Number
        },
        computed: {
            code () {
                this.getResult()
            }
        },
        watch: {
            firstNumber () {
                this.getResult()
            }
        },
        mounted() {
            this.randomNUmber()
            // console.log( this.code )
        },
        methods: {
            // 生成随机数
            randomNUmber () {
                this.type = Math.floor( Math.random() * 3 )
                this.firstNumber = Math.floor( Math.random() * this.max ) + 1
                this.secondNumber = Math.floor( Math.random() * this.min ) + 1
                if ( this.firstNumber < this.secondNumber ) {
                    this.randomNUmber()
                } else {
                    setInterval( () => {
                        this.randomNUmber()
                    }, 60 * 1000)
                }
                
            },
            // 计算结果
            getResult () {
                let result = ""
                 if ( this.type == 0 ) {
                    result =  Number( this.firstNumber ) + Number( this.secondNumber )
                } else if ( this.type == 1 ) {
                    result = Number( this.firstNumber ) - Number( this.secondNumber )
                } else if ( this.type == 2 ) {
                    result = Number( this.firstNumber ) * Number( this.secondNumber )
                }
                console.log( result )
                this.$emit("getResultCode", result )
                return result
            }
        }
    }
</script>

<style lang="scss" scoped>
.code_box {
    width: 120px;
    height: 50px;
    line-height: 50px;
    display: flex;
    background: rgba(183, 180, 180, 0.35);
    color: #686868;
    justify-content: center;
    cursor: pointer;
    .number {
        width: 30px;
        text-align: center;
    }
}
</style>